import { BaseEntity } from '~/app/core/models/base-entity.model';

export class Context extends BaseEntity<Context> {
  code?: string;
  name?: string;
  description?: string;
  type?: string;
  active?: number;
  parent?: {
    id: string;
  };
}
